module.exports = __webpack_public_path__ + "img/Call-center-bro.4ec75e7b.png";